<template>
  <v-card
    id="switchTeamCard"
    flat
    class="pa-4"
    :width="fromWelcome ? '' : '400'"
  >
    <v-row>
      <v-col
        :class="fromWelcome ? 'mt-1 mb-3 px-0' : ''"
        class="font-size-h3 bold-text dark-grey-text"
        cols="12"
      >
        Switch teams
      </v-col>
    </v-row>
    <v-row class="">
      <v-card
        :outlined="fromWelcome"
        :flat="!fromWelcome"
        width="100%"
        class="pb-2"
      >
        <v-col cols="12">
          <v-row align="center">
            <v-col>
              <div>
                <div class="text-muted dark-grey-text">Active teams</div>
              </div>
            </v-col>
            <v-col v-if="!fromWelcome" class="text-right">
              <v-btn
                text
                color="primary"
                id="createNewTeamBtn"
                class="text-transform-none"
                @click="createTeamModal = true"
              >
                <span>Create new team </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="py-0" cols="12">
          <v-row v-if="loading">
            <v-col cols="12" v-for="i in 2" :key="i">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-col>
          </v-row>
          <template v-else>
            <v-row
              class="lightBackground my-3"
              align="center"
              v-for="(team, index) in getTeamList"
              :id="`switchAbleTeamRow${team.id}`"
              :key="index"
            >
              <v-col class="dark-grey-text font-size-h4">
                <div>
                  {{ team.name }}
                </div>
                <div v-if="team.status == 2" class="caption error--text">
                  Inactive
                </div>
              </v-col>
              <v-col class="text-right">
                <v-chip
                  v-if="getTeamId !== team.id"
                  @click="switchTeam(team)"
                  color="primary"
                  :id="`switch${index}`"
                  class="text-transform-none"
                  label
                >
                  <div class="px-1 bold-text">Switch</div>
                </v-chip>
                <v-chip id="currentChip" v-else color="success" label>
                  <div class="bold-text">Current</div>
                </v-chip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0 text-right">
                <div style="display: flex; justify-content: end">
                  <v-pagination
                    v-if="getTotalTeamCount > 4"
                    flat
                    id="paginationComponent"
                    class="ml-auto"
                    v-model="page"
                    :length="totalLength || 0"
                    :disabled="getTotalTeamCount < 4"
                    :total-visible="0"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-card>
      <Modal
        v-model="showSuccessTeamSwitch"
        @close="showSuccessTeamSwitch = false"
      >
        <template #message>
          <v-row>
            <v-col class="my-4 font-size-h3 bold-text" cols="12">
              Switching teams
            </v-col>
            <v-col class="text-center" cols="12">
              <v-progress-circular indeterminate></v-progress-circular>
            </v-col>
            <v-col class="text-center" cols="12">Please wait...</v-col>
          </v-row>
        </template>
      </Modal>
      <Modal v-model="createTeamModal" @close="createTeamModal = false">
        <template #message>
          <v-row v-if="createTeamModal">
            <v-col class="mt-4 bold-text font-size-h3" cols="12">
              Create a new team
            </v-col>
          </v-row>
          <create-team
            from-switch-team
            @teamCreated="afterSuccess"
          ></create-team>
        </template>
      </Modal>
    </v-row>
  </v-card>
</template>

<script>
import { GET_TEAMS, SWITCH_TEAM } from "@/store/team/manageTeam.module.js";
import { UPDATE_USER_TOKEN } from "@/store/users/auth.module";
import CreateTeam from "@/view/components/Team/Create.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    fromWelcome: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CreateTeam,
  },
  data() {
    return {
      loading: false,
      modal: false,
      createTeamModal: false,
      successModalMessage: "",
      showSuccessTeamSwitch: false,

      page: 1,
      selectedTeam: {},
    };
  },
  computed: {
    ...mapGetters({
      getTeamList: "getTeamList",
      getTeamId: "getTeamId",
      getTotalTeamList: "getTotalTeamList",
      getTotalTeamCount: "getTotalTeamCount",
    }),
    totalLength() {
      return Math.ceil(this.getTotalTeamCount / 4);
    },
  },
  watch: {
    page(val, oldVal) {
      let offset = (val - 1) * 4;
      let limit = val * 4;
      // checked if it is next or previous
      if (val > oldVal) {
        //  if next and all the data are already fetched
        if (
          this.getTotalTeamList &&
          this.getTotalTeamList.length > oldVal * 4
        ) {
          this.setPreviousTeamData(this.getTotalTeamList.slice(offset, limit));
        } else {
          // if it is first time, get last id and hit api
          const lastId = this.getTeamList[this.getTeamList.length - 1].id;
          this.getTeamsList(lastId);
        }
      } else {
        // if it is previous then show already fetched data
        this.setPreviousTeamData(this.getTotalTeamList.slice(offset, limit));
      }
    },
  },
  created() {
    if (!this.fromWelcome) {
      this.getTeamsList();
    }
    window.analytics.track("Opened switch teams");
  },
  methods: {
    ...mapMutations({
      setPreviousTeamData: "setPreviousTeamData",
    }),
    getTeamsList(lastId) {
      this.createTeamModal = false;
      if (this.loading) return;
      this.loading = true;
      this.$store
        .dispatch(GET_TEAMS, lastId)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async afterSuccess() {
      this.createTeamModal = false;
      if (this.$route.params && this.$route.params.app_id) {
        await this.$router.push({ name: "apps" });
      }
      this.showSuccessTeamSwitch = true;
      this.$nextTick(() => {
        window.location.reload();
      });
    },
    switchTeam(details) {
      if (this.loading) return;
      this.loading = true;
      this.$store
        .dispatch(SWITCH_TEAM, details.id)
        .then((response) => {
          this.successModalMessage = response.data.message;
          this.afterSuccess();
          // this.$store.dispatch(CLEAR_STORE);
          this.$store.dispatch(UPDATE_USER_TOKEN, response.data.token);
          this.loading = false;
        })
        .catch((err) => {
          this.notifyErrorMessage(err.message);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
